import React from 'react';
import { useLanguage } from './LanguageContext';

export default function LangToggle({ style }) {
  const { lang, toggleLang } = useLanguage();
  return (
    <button
      onClick={toggleLang}
      title={lang === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
      style={{
        background: 'rgba(124,109,248,0.15)',
        border: '1px solid rgba(124,109,248,0.4)',
        borderRadius: 8,
        color: '#a78bfa',
        fontSize: 12,
        fontWeight: 700,
        padding: '5px 10px',
        cursor: 'pointer',
        fontFamily: 'Tajawal, sans-serif',
        letterSpacing: 0.5,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {lang === 'ar' ? 'EN' : 'عربي'}
    </button>
  );
}
